import { useMutation } from 'react-query';
import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { getClient } from 'src/util/mdello-instance';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';
import { CreateRequestParams } from './interfaces/createRequest.interface';

const createRequestAction = async (body: CreateRequestParams): Promise<void> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  await getClient()?.createEntity(
    {
      kind: EntityKind.REQUEST_ACTION,
      projectId: currentProject._id
    },
    body
  );
};

export const useCreateRequestAction = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(
    // @ts-ignore-next-line
    (params: { body: CreateRequestParams }) => {
      createRequestAction(params.body);
    },
    {
      onError: () => {
        notify({ message: 'something went wrong', severity: 'error' });
        if (onError) {
          onError();
        }
      },
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  );
};
